__webpack_require__.p = "/scareBears/";